import { ConfigurationType } from 'data/types';

export function showsLayoutDiagramDuctRuns(
  configuration: Pick<ConfigurationType, 'type'>
): boolean {
  return configuration.type === 'ductless';
}
